import React from 'react';
import { Trans } from 'react-i18next';

import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import BasePage from 'apps/auth/components/utils/BasePage';
import { HELP } from 'apps/auth/constants/UrlConstants';
import { getLangCountryPrefix } from 'apps/auth/helpers/utils';
import { useApp, useLanguage } from 'apps/auth/hooks/selectors';

const NotFound = () => {
    const { country } = useApp();
    const { lang } = useLanguage();
    const helpLink = `${getLangCountryPrefix(lang, country)}${HELP}`;

    return (
        <InfoPage
            animatedIconFail
            headerText={<Trans>ps.404.header.text</Trans>}
            secondaryText={<Trans>ps.404.error.description</Trans>}
            buttonRowType="link"
            buttonRowCaption={<Trans>ps.404.help</Trans>}
            buttonRowHref={helpLink}
        />
    );
};

export default BasePage(NotFound, '/');
